export default {
  routerPaths: [
    {
      path: '/is-heatmonitoring/meter-points',
      name: 'ISHeatMonitoringMeterPointList',
      view: 'is/heatMonitoring/meterPointList',
      meta: {
        isDrawerIconLink: true,
        i18n: 'IS.HeatMonitoring.drawer.isHeatMonitoringMeterPoints',
        permissions: {
          and: [
            { subject: 'IsHeatMonitoring', action: 'read' },
            { subject: 'DigitalTwin', action: 'read' },
          ],
        },
      },
    },
    {
      path: '/is-heatmonitoring/meter-points/:id',
      name: 'ISHeatMonitoringMeterPointDetails',
      view: 'is/heatMonitoring/meterPointDetails',
      meta: {
        i18n: 'IS.HeatMonitoring.drawer.isHeatMonitoringMeterPoints',
        permissions: {
          and: [
            { subject: 'IsHeatMonitoring', action: 'read' },
            { subject: 'DigitalTwin', action: 'read' },
          ],
        },
      },
    },
    {
      path: '/is-heatmonitoring/map',
      name: 'ISHeatMonitoringMeterPointMap',
      view: 'is/heatMonitoring/meterPointMap',
      meta: {
        i18n: 'IS.HeatMonitoring.drawer.isHeatMonitoringMap',
        permissions: {
          and: [
            { subject: 'IsHeatMonitoring', action: 'read' },
            { subject: 'DigitalTwin', action: 'read' },
          ],
        },
      },
    },
    {
      path: '/is-heatmonitoring/meters',
      name: 'ISHeatMonitoringMeterList',
      view: 'is/heatMonitoring/meterList',
      meta: {
        i18n: 'IS.HeatMonitoring.drawer.isHeatMonitoringMeters',
        permissions: {
          and: [
            { subject: 'IsHeatMonitoring', action: 'read' },
            { subject: 'VirtualDevice', action: 'read' },
          ],
        },
      },
    },
    {
      path: '/is-heatmonitoring/meters/:id',
      name: 'ISHeatMonitoringMeterDetails',
      view: 'is/heatMonitoring/meterDetails',
      meta: {
        i18n: 'IS.HeatMonitoring.drawer.isHeatMonitoringMeters',
        permissions: {
          and: [
            { subject: 'IsHeatMonitoring', action: 'read' },
            { subject: 'VirtualDevice', action: 'read' },
          ],
        },
      },
    },
  ],
  drawerLinks: [
    {
      icon: 'fal fa-tachometer-alt-fast',
      text: 'IS.HeatMonitoring.drawer.isHeatMonitoring',
      children: [
        {
          to: '/is-heatmonitoring/meter-points',
          icon: 'fal fa-list-ul',
          text: 'IS.HeatMonitoring.drawer.isHeatMonitoringMeterPoints',
        },
        {
          to: '/is-heatmonitoring/meters',
          icon: 'fal fa-sensor',
          text: 'IS.HeatMonitoring.drawer.isHeatMonitoringMeters',
        },
        {
          to: '/is-heatmonitoring/map',
          icon: 'fal fa-map-marked-alt',
          text: 'IS.HeatMonitoring.drawer.isHeatMonitoringMap',
        },
      ],
    },
  ],
};
